import React from "react";
import i18n from "../../../../constants/i18n";
import getUserMessagesStore from "../../../../stores/user-store/messages-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import LoadMoreButton from "./LoadMoreButton";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import SocialMediaBadWordsCounter from "../../../../components/SocialMediaBadWordsCounter";
import ET3Div from "../../../../core/et3-div";
import { USER_MESSAGES_HEADERS } from "../../../../constants/table-custom-headers/User";

const UserMessagesData = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const searchedUser = getUserMessagesStore().searchedUser.get();
  const userMessagesData = getUserMessagesStore().userMessagesData.get();
  const messagesData = getUserMessagesStore().getMessagesData(
    userMessagesData,
    searchedUser
  );
  const socialMediaBadWordsCount =
    getUserMessagesStore().getBadWordsAndSocialMediaCount(messagesData);

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={1500}
        height={100}
        fDirection="column"
        alignItems="flex-end"
        justifyContent="center"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <SocialMediaBadWordsCounter
          socialMediaBadWordsCount={socialMediaBadWordsCount}
        />
        <Et3Margin top={30} bottom={0} left={0} right={0} />
        <Et3Table
          columns={USER_MESSAGES_HEADERS}
          rows={messagesData}
          title={i18n.get("USER_MESSAGES_TABLE")}
          shouldBeFlagged={false}
          titleKey={"USER_MESSAGES_TABLE"}
        />
        <Et3Margin top={30} bottom={0} left={0} right={0} />
        <LoadMoreButton />
      </ET3Div>
    </React.Fragment>
  );
});
export default UserMessagesData;
